import React, { useState } from 'react';
import { Globe, Clock } from 'lucide-react';
import { MarketplacesHub, OfferAutomationManager } from './AdminMasterPage';

export default function MarketplacesPage() {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  const [subtab, setSubtab] = useState('stores');

  const tabs = [
    { key: 'stores', label: 'Lojas conectadas', icon: Globe, testid: 'marketplaces-subtab-stores' },
    { key: 'automation', label: 'Cerebro de Ofertas', icon: Clock, testid: 'marketplaces-subtab-automation' },
  ];

  return (
    <div className="space-y-4" data-testid="marketplaces-page">
      <div
        className="inline-flex items-center gap-0.5 p-1 rounded-xl"
        style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}
        data-testid="marketplaces-subtabs"
      >
        {tabs.map(t => {
          const active = subtab === t.key;
          const Icon = t.icon;
          return (
            <button
              key={t.key}
              type="button"
              onClick={() => setSubtab(t.key)}
              className="px-3.5 py-1.5 rounded-lg text-xs font-semibold flex items-center gap-1.5 transition-all"
              style={{
                background: active ? 'var(--sv-gold-primary)' : 'transparent',
                color: active ? '#0A0A0A' : 'var(--muted)',
              }}
              data-testid={t.testid}
            >
              <Icon size={12} /> {t.label}
            </button>
          );
        })}
      </div>

      {subtab === 'stores' && <MarketplacesHub token={token} />}
      {subtab === 'automation' && <OfferAutomationManager token={token} />}
    </div>
  );
}
